import { Whitelabel } from '../../app/whitelabel/contract/whitelabel.contract';
import { IconsetKey } from '../iconset-key.enum';
import { ThemeKey } from '../theme-key.enum';

export const Osp: Whitelabel = {
  whitelabeledComponents: {},
  iconSet: IconsetKey.OSP,
  defaultTheme: ThemeKey.OSP_LIGHT,
  availableThemes: [ThemeKey.OSP_LIGHT],
};
